import React, { useState } from "react";

export default function NewsletterPopup({ open, onClose }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await fetch("http://localhost:4000/api/subscribers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error("error");

      setSuccess(true);
      setEmail("");

    } catch (err) {
      console.error(err);
      alert("Error al suscribirte");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        
        {/* CLOSE */}
        <button style={closeBtn} onClick={onClose}>×</button>

        {!success ? (
          <div style={rowLayout}>

           {/* IZQUIERDA — IMAGEN */}
           <div style={imageSide} />

           {/* DERECHA — CONTENIDO */}
           <div style={contentSide}>

             <h2 style={title}>ZEDRO NEWS</h2>

             <p style={headline}>
               Una idea clara puede reordenar toda tu semana.
             </p>

             <p style={subtitle}>
               Recibe cada edición con ideas prácticas para pensar mejor, decidir con claridad y ejecutar al instante.
             </p>

             <p style={socialProof}>
               Personas que están construyendo con intención ya están dentro.
             </p>

             <form onSubmit={handleSubmit} style={form}>
               <input
                 type="email"
                 placeholder="Tu correo electrónico"
                 value={email}
                 onChange={(e) => setEmail(e.target.value)}
                 style={input}
                 required
               />

               <button type="submit" style={button} disabled={loading}>
                 {loading ? "Procesando..." : "Haz parte de ZEDRO Academy"}
               </button>
             </form>

             <p style={note}>
               Puedes darte de baja en cualquier momento.
             </p>

           </div>
         </div>
       ) : (
         <>
           <h2 style={title}>¡Buena decisión!</h2>
           <p style={subtitle}>
             Ya haces parte de ZEDRO.Academy.
           </p>

           <button style={button} onClick={onClose}>
             Cerrar
           </button>
         </>
       )}
      </div>
    </div>
  );
}

/* ========================= STYLES ========================= */

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modal = {
  background: "#ffffff",
  backdropFilter: "blur(6px)",
  borderRadius: "16px",
  maxWidth: "720px",
  width: "92%",
  padding: "16px",
  textAlign: "center",
  position: "relative",
  boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
  overflow: "hidden",
};

const closeBtn = {
  position: "absolute",
  top: "12px",
  right: "12px",
  background: "none",
  border: "none",
  fontSize: "20px",
  cursor: "pointer",
};

const content = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

const image = {
  width: "100%",
  height: "80px",
  borderRadius: "10px",
  backgroundImage:
    "url('/assets/images/newsletter/hero/zedro-editorial-popup.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  marginBottom: "14px",
};

const title = {
  margin: 0,
};

const headline = {
  fontWeight: 600,
  fontSize: "17px",
  lineHeight: "1.4",
};

const subtitle = {
  fontSize: "14px",
  color: "#555",
};

const socialProof = {
  fontSize: "13px",
  color: "#777",
};

const form = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "10px",
};

const input = {
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ddd",
};

const button = {
  padding: "8px",
  borderRadius: "8px",
  border: "none",
  background: "#111",
  color: "#fff",
  cursor: "pointer",
  fontWeight: 500,
};

const note = {
  fontSize: "12px",
  color: "#999",
};

const rowLayout = {
  display: "flex",
  gap: "18px",
  alignItems: "stretch",
  minHeight: "260px",
};

const imageSide = {
  width: "45%",
  borderRadius: "12px",
  backgroundImage:
    "url('/assets/images/newsletter/hero/zedro-editorial-popup.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "220px",
};

const contentSide = {
  width: "55%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "6px",
};